import { toast } from "react-hot-toast";

const formatMessage = (message) => {
  if (Array.isArray(message)) {
    message = message.map((msg, index) => index + 1 + ". " + msg);
    message = message.join("\n");
  }
  return message;
};

const options = {
  position: "bottom-right",
  hideAfter: 4,
};

export const showSuccessToaster = (message = "", id) => {
  message = formatMessage(message);
  toast.success(message, {
    position: "top-right",
    id: id,
    style: {
      minWidth: "250px",
      maxWidth: "350px",
      background: "#333",
      color: "#fff",
    },
  });
};

export const showErrorToaster = (message = "", id) => {
  message = formatMessage(message);
  toast.error(message, {
    position: "top-right",
    id: id,
    style: {
      minWidth: "250px",
      maxWidth: "350px",
      background: "#333",
      color: "#fff",
    },
  });
};

export const showLoadingToaster = (message = "", id) => {
  message = formatMessage(message);
  toast.loading(message, {
    position: "top-right",
    id: id,
    style: {
      minWidth: "250px",
      maxWidth: "350px",
      background: "#333",
      color: "#fff",
    },
  });
};

export const dismissToaster = () => {
  toast.dismiss();
};
